// extracted by mini-css-extract-plugin
module.exports = {"explainer":"donate_explainer__5I4RE","donateForm":"donate_donateForm__8aoVS"};